// /chat — the conversation list, full page (docs/plans/2026-09-30-runners/
// 07-chat.md §2.8). No conversation selected yet: picking one navigates to
// /chat/$conversationId (see ./detail.tsx), which renders the same list
// alongside the open conversation.

import { useState } from 'react'
import { useNavigate } from '@tanstack/react-router'
import type { ChatConversation } from '@goblic/shared'
import { ConversationList } from '../../components/chat/conversation-list'
import { NewConversationForm } from '../../components/chat/new-conversation-form'
import { EmptyState } from '../../components/ui'

export function ChatPage() {
  const navigate = useNavigate()
  const [newOpen, setNewOpen] = useState(false)

  function open(conversation: ChatConversation): void {
    void navigate({ to: '/chat/$conversationId', params: { conversationId: conversation.id } })
  }

  return (
    <div className="flex h-full">
      <div className="w-80 shrink-0 border-r border-line">
        <ConversationList activeId={undefined} onSelect={open} onNew={() => setNewOpen(true)} />
      </div>
      <div className="flex-1">
        <EmptyState title="Pick a conversation" art="empty">
          Or start a new one — the assistant acts with your own permissions.
        </EmptyState>
      </div>
      <NewConversationForm open={newOpen} onClose={() => setNewOpen(false)} onCreated={open} />
    </div>
  )
}
